var _excluded = ["buttonBackground", "buttonColor", "buttonHoverBackground", "buttonHoverColor", "buttonSize", "type", "position", "setPosition", "showArrowsOnHover"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonBack, ButtonNext } from 'pure-react-carousel';
import { ChevronRight, ChevronLeft } from 'pcln-icons';
import { Wrapper } from './ArrowButton.styles';
var ArrowButton = function ArrowButton(_ref) {
  var _ref$buttonBackground = _ref.buttonBackground,
    buttonBackground = _ref$buttonBackground === void 0 ? 'background.lightest' : _ref$buttonBackground,
    _ref$buttonColor = _ref.buttonColor,
    buttonColor = _ref$buttonColor === void 0 ? 'primary.base' : _ref$buttonColor,
    _ref$buttonHoverBackg = _ref.buttonHoverBackground,
    buttonHoverBackground = _ref$buttonHoverBackg === void 0 ? 'background.base' : _ref$buttonHoverBackg,
    _ref$buttonHoverColor = _ref.buttonHoverColor,
    buttonHoverColor = _ref$buttonHoverColor === void 0 ? 'primary.dark' : _ref$buttonHoverColor,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? '60px' : _ref$buttonSize,
    type = _ref.type,
    position = _ref.position,
    setPosition = _ref.setPosition,
    showArrowsOnHover = _ref.showArrowsOnHover,
    props = _objectWithoutProperties(_ref, _excluded);
  return setPosition === position ? /*#__PURE__*/React.createElement(Wrapper, _extends({
    buttonBackground: buttonBackground,
    buttonColor: buttonColor,
    buttonHoverBackground: buttonHoverBackground,
    buttonHoverColor: buttonHoverColor,
    buttonSize: buttonSize,
    type: type,
    position: position
  }, props, {
    "data-testid": "".concat(type, "-").concat(position),
    showArrowsOnHover: showArrowsOnHover
  }), type === 'prev' ? /*#__PURE__*/React.createElement(ButtonBack, null, /*#__PURE__*/React.createElement(ChevronLeft, {
    size: type === 'side' ? 40 : 32,
    ml: "-3px"
  })) : /*#__PURE__*/React.createElement(ButtonNext, null, /*#__PURE__*/React.createElement(ChevronRight, {
    size: type === 'side' ? 40 : 32,
    mr: "-3px"
  }))) : null;
};
ArrowButton.propTypes = {
  type: PropTypes.oneOf(['prev', 'next']),
  position: PropTypes.oneOf(['side', 'top', 'bottom', 'hide']),
  setPosition: PropTypes.oneOf(['side', 'top', 'bottom', 'hide']),
  /** color.shade pattern to be passed to getPaletteColor */
  buttonBackground: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonColor: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonHoverBackground: PropTypes.string,
  /** color.shade pattern to be passed to getPaletteColor */
  buttonHoverColor: PropTypes.string,
  /** same value used for button width and button height */
  buttonSize: PropTypes.string,
  /** When arrow position is side, hide arrows and shows when hovers on carousel */
  showArrowsOnHover: PropTypes.bool,
  /** adjust side arrow position for overflow */
  overflowAdjust: PropTypes.number
};
export { ArrowButton };